<template>
  <bar-chart ref="chartFranquias" :chart-data="datacollection" :options="opts"></bar-chart>
</template>


<style lang="scss">
    @import './DesempenhoHistoricoFranquia.scss';
</style>
<script>
  import Message from '@/helpers/message';
  import BarChart from '@/components/common/Charts/Bar';
  import ConverterHelper from '@/helpers/converter';
  import { post } from '@/helpers/api';
  import { RESPONSIVE } from '@/constants/chart';
  import Events from '@/helpers/events';
  import _ from 'lodash';
  import {
          ESTAGIO_PROSPECCAO,
          ESTAGIO_CHAMADA_TELEFONICA,
          ESTAGIO_PRIMEIRA_VISITA,
          ESTAGIO_EFETIVADO,
          ESTAGIO_NEGATIVADO,
          ESTAGIO_SEGUNDA_VISITA,
          ESTAGIO_EM_ESPERA,
          ESTAGIO_PERDIDO,
          ESTAGIO_NEGOCIACAO,
      } from '@/constants/pedidoEstagio.js';


  export default {
    name: "DesempenhoHistoricoFranquias",
    components: {
      BarChart
    },
    data () {
      return {
        datacollection: null,
        opts: RESPONSIVE,
        allItens: [],
        addedItens: []

      }
    },
    props:{
        filtros: {
            type: Object,
        },
        addItem: {
            type: Number,
            default: null,
        },
        removeItem: {
            type: Number,
            default: null,
        },

    },
    created() {
      // debugger;
    },
    mounted () {
    this.$parent.$emit('showLoading', true);
     this.getData();
      // const self = this;
      // this.$refs.chartFranquias.onclick =

    },
    watch: {
      filtros(newValue){
        console.log('filtros', this.filtros)
        this.getData();
      },
      addItem(newValue){
        console.log('to de add');
        if(newValue){
          this.getDataFranquia(newValue)
        }
      },
      removeItem(newValue){
        console.log('to de remove');
        const newData = this.addedItens.filter(franquia => franquia.id_franquia != newValue);
        this.addedItens = newData;
        this.preFill();
      },
    },
    methods: {
      preFill(order = false){
        const self = this;
        let newLista = this.allItens.concat(this.addedItens);
        if(order || this.addedItens.length){
          newLista = newLista.sort((franquiaA, franquiaB) => {
            if(self.filtros.order === 'desc'){
              return franquiaB.leads_efetivados - franquiaA.leads_efetivados
            }else{
              return franquiaA.leads_efetivados - franquiaB.leads_efetivados
            }
            })
        }
        this.fill(newLista);
      },
      getDataFranquia(id_franquia){
        console.log('id_franfran', id_franquia);
        if(!this.allItens.some(franquia => franquia.id_franquia == id_franquia)){
          this.$emit('load', true);
          const newFiltro = this.prepareFilters();
          const self = this;
          post('grafico/lista-desempenhos',{...newFiltro, id_franquia}).then(function (response) {
          const listaDesempenho = response.data.result.data;
          if(listaDesempenho.length){
            self.addedItens.push(listaDesempenho[0]);
            self.preFill(true);
          }else{
            self.$emit('load', false);
            Message.messageError('Franquia não possui dados');
            self.$emit('removeFranquia', id_franquia);
          }
          }).catch(err =>  self.$emit('load', true))
        }else{
          this.$emit('removeFranquia', id_franquia);
        }
      },
      prepareFilters(){
        const newFiltro = {...this.filtros};
        newFiltro.data_ini = moment(newFiltro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
        newFiltro.data_fim = moment(newFiltro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        newFiltro.page_qtd= 5;
        newFiltro.page_ini= 1;
        return newFiltro;
      },
      getData(){
      this.$emit('load', true);
      let self = this;

        const newFiltro = this.prepareFilters();
        post('grafico/lista-desempenhos',{...newFiltro}).then(function (response) {
        const listaDesempenho = response.data.result.data;
        self.allItens = listaDesempenho;
        if(!self.allItens.length){
          self.$emit('load', true)
        }
        self.preFill();
        }).catch(err =>  self.$emit('load', true))
      },
      fill(listaDesempenho){

         console.log(listaDesempenho, this);
        let graficoInformacoes = {
            labels: [],
            datasets: []
          };

          const estagiosPadroes = [ESTAGIO_EM_ESPERA,ESTAGIO_CHAMADA_TELEFONICA, ESTAGIO_EFETIVADO, ESTAGIO_PROSPECCAO, ESTAGIO_SEGUNDA_VISITA, ESTAGIO_NEGATIVADO, ESTAGIO_NEGOCIACAO, ESTAGIO_PRIMEIRA_VISITA];
          console.log('estagios padores', estagiosPadroes);

          estagiosPadroes.forEach((element, key) => {

            const tmpDatas =  [];
            listaDesempenho.forEach(element => {
                tmpDatas.push(0);
            });
            graficoInformacoes.datasets.push(
              {
                id: element,
                label: ConverterHelper.getNameEstagio(element),
                backgroundColor: ConverterHelper.getCorEstagio(element),
                borderColor: ConverterHelper.getCorEstagio(element),
                borderWidth: 1,
                hidden: element != ESTAGIO_EFETIVADO,
                data: tmpDatas
            });
          });
          let adicionadosLabels = [];

                listaDesempenho.forEach( (franquia, numFranquia) => {
                if(!adicionadosLabels.includes(franquia.id_franquia)){
                  // nome da parte de baixo
                  graficoInformacoes.labels.push(ConverterHelper.formatLabelChart(franquia.nome_franquia, 15));
                }

                const dadosRelatorio = [];
                franquia.estagio.forEach(estagio => {
                  if(ESTAGIO_PERDIDO != estagio.id_estagio){
                    graficoInformacoes.datasets[estagiosPadroes.indexOf(estagio.id_estagio)].label = ConverterHelper.getStatusName(estagio.estagio_nome);
                    graficoInformacoes.datasets[estagiosPadroes.indexOf(estagio.id_estagio)].data[numFranquia] = estagio.total;


                    //  novoEstagiosPadroes[estagio.id_estagio] = estagio.total;
                    //   console.log('estagio', estagio);
                    //   console.log(estagioIdsVisitados);
                    // if(estagioIdsVisitados.includes(estagio.id_estagio)){
                    //   const indexVisitado = estagioIdsVisitados.indexOf(estagio.id_estagio);
                    //   graficoInformacoes.datasets[indexVisitado].data.push(estagio.total);
                    // }else{
                    //   graficoInformacoes.datasets.push(
                    //     {
                    //       id: estagio.id_estagio,
                    //       label: estagio.estagio_nome,
                    //       backgroundColor: ConverterHelper.getCorEstagio(estagio.id_estagio),
                    //       borderColor: ConverterHelper.getCorEstagio(estagio.id_estagio),
                    //       borderWidth: 1,
                    //       hidden: estagio.id_estagio != ESTAGIO_EFETIVADO,
                    //       data: [estagio.total]
                    //     });

                    //     estagioIdsVisitados.push(estagio.id_estagio);
                    // }
                  }

                });

            })
          this.$emit('load', false);
          this.datacollection = graficoInformacoes;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/DesempenhoHistoricoFranquias.vue